"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _modal = require("@jsluna/modal");

var _form = require("@jsluna/form");

var _button = require("@jsluna/button");

var _conditions = require("./data/conditions");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var BranchOptionModal = function BranchOptionModal(_ref) {
  var questions = _ref.questions,
      setQuestions = _ref.setQuestions,
      branchFromId = _ref.branchFromId,
      branchFromValue = _ref.branchFromValue,
      isOpen = _ref.isOpen,
      setIsOpen = _ref.setIsOpen;

  var getCurrentBranchValue = function getCurrentBranchValue() {
    var questionConditions = (0, _conditions.getLinkedQuestionConditions)(questions, branchFromId);
    if (!questionConditions) return null;
    if (questionConditions.length === 0) return null;
    var values = questionConditions.filter(function (x) {
      return x.value === branchFromValue;
    });
    return values.length > 0 ? values[0].question.id : null;
  };

  var initialValue = getCurrentBranchValue();

  var _useState = (0, _react.useState)(initialValue),
      value = _useState[0],
      setValue = _useState[1];

  var options = questions.filter(function (y) {
    return branchFromId && y.id !== branchFromId && y.position > questions.filter(function (q) {
      return q.id === branchFromId;
    })[0].position;
  }).sort(function (a, b) {
    return a.position - b.position;
  }).map(function (x) {
    return {
      label: "Question " + x.position,
      value: x.id
    };
  });

  var _handleClose = function handleClose() {
    setValue(null);
    setIsOpen(false);
  };

  var handleAddBranch = function handleAddBranch() {
    var condition = (0, _conditions.createCondition)(branchFromId, branchFromValue);
    var updatedQuestions = (0, _conditions.removeConditionFromQuestions)(questions, initialValue, condition);
    updatedQuestions = (0, _conditions.addConditionToQuestions)(updatedQuestions, value, condition);
    setQuestions(updatedQuestions);

    _handleClose();
  };

  var handleDeleteBranch = function handleDeleteBranch() {
    var condition = (0, _conditions.createCondition)(branchFromId, branchFromValue);
    var updatedQuestions = (0, _conditions.removeConditionFromQuestions)(questions, initialValue, condition);
    setQuestions(updatedQuestions);

    _handleClose();
  };

  return /*#__PURE__*/_react.default.createElement(_modal.Modal, {
    open: isOpen,
    handleClose: function handleClose() {
      return _handleClose(false);
    },
    small: true
  }, /*#__PURE__*/_react.default.createElement("h4", null, "Branch to which question"), /*#__PURE__*/_react.default.createElement("p", null, "Once this question / option is answered, which question should the colleague then progress to?"), /*#__PURE__*/_react.default.createElement(_form.SelectField, {
    name: "BranchOptionModal-SelectField",
    options: options,
    label: "Select a question to progress to",
    value: !value ? initialValue : value,
    onChange: function onChange(e) {
      return setValue(e.target.value);
    }
  }), initialValue ? /*#__PURE__*/_react.default.createElement(_button.OutlinedButton, {
    fullWidth: true,
    onClick: function onClick() {
      return handleDeleteBranch();
    },
    className: "ln-u-margin-bottom"
  }, "Remove existing branch") : /*#__PURE__*/_react.default.createElement("div", null), /*#__PURE__*/_react.default.createElement(_button.OutlinedButton, {
    fullWidth: true,
    onClick: function onClick() {
      return _handleClose();
    },
    className: "ln-u-margin-bottom"
  }, "Cancel"), /*#__PURE__*/_react.default.createElement(_button.FilledButton, {
    fullWidth: true,
    onClick: function onClick() {
      return handleAddBranch();
    },
    disabled: !value || value === initialValue
  }, "Create branch"));
};

BranchOptionModal.propTypes = {
  /** Array containing the information of each question */
  questions: _propTypes.default.arrayOf(_propTypes.default.shape({
    /** The unique identifier of the question */
    id: _propTypes.default.string,

    /** The position of the question in the survey */
    position: _propTypes.default.number,

    /** The title of the question */
    title: _propTypes.default.string,

    /** The supporting description of the question */
    description: _propTypes.default.string,

    /** The conditions a question has to be displayed */
    conditions: _propTypes.default.array,

    /** Information on the component to be rendered for the question */
    component: _propTypes.default.shape({
      /** The type of component the question should render */
      type: _propTypes.default.string,

      /** The props to be passed to the rendered question component */
      props: _propTypes.default.object
    })
  })).isRequired,

  /** Function to amend the current list of questions */
  setQuestions: _propTypes.default.func.isRequired,

  /** The id of the question that is being branched from */
  branchFromId: _propTypes.default.string,

  /** The value of the question that is being branched from */
  branchFromValue: _propTypes.default.any,

  /** Indicates whether the modal should be open or not */
  isOpen: _propTypes.default.bool.isRequired,

  /** Function to control the value of isOpen */
  setIsOpen: _propTypes.default.func.isRequired
};
BranchOptionModal.defaultProps = {
  branchFromId: null,
  branchFromValue: null
};
var _default = BranchOptionModal;
exports.default = _default;